import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import MobileLayout from '../../components/MobileLayout';
import { useTranslation } from 'react-i18next';

const Guidelines: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <MobileLayout>
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <div className="px-6 py-4 border-b border-dark-border dark:border-dark-border border-light-border">
          <div className="flex items-center">
            <button
              onClick={() => navigate('/profile')}
              className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-dark-surface dark:hover:bg-dark-surface hover:bg-light-surface"
            >
              <ArrowLeftIcon className="w-5 h-5 text-dark-text dark:text-dark-text text-light-text" />
            </button>
            <h1 className="ml-4 text-xl font-semibold text-dark-text dark:text-dark-text text-light-text">
              {t('legal.guidelines.title', 'Community Guidelines')}
            </h1>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-6 py-6">
          <div className="prose prose-invert max-w-none">
            <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary mb-4">
              {t(
                'legal.guidelines.intro',
                'These guidelines help maintain a safe and respectful environment for all users.',
              )}
            </p>

            <h2 className="text-lg font-semibold text-dark-text dark:text-dark-text text-light-text mb-3">
              {t('legal.guidelines.beRespectful.title', 'Be Respectful')}
            </h2>
            <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary mb-4">
              {t(
                'legal.guidelines.beRespectful.content',
                'Treat AI companions with respect. While they are AI, maintaining respectful interactions creates a better experience for everyone.',
              )}
            </p>

            <h2 className="text-lg font-semibold text-dark-text dark:text-dark-text text-light-text mb-3">
              {t('legal.guidelines.noIllegalContent.title', 'No Illegal Content')}
            </h2>
            <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary mb-4">
              {t(
                'legal.guidelines.noIllegalContent.content',
                'Do not attempt to use the service for illegal activities, including but not limited to fraud, harassment, or distribution of illegal content.',
              )}
            </p>

            <h2 className="text-lg font-semibold text-dark-text dark:text-dark-text text-light-text mb-3">
              {t('legal.guidelines.ageAppropriate.title', 'Age Appropriate')}
            </h2>
            <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary mb-4">
              {t(
                'legal.guidelines.ageAppropriate.content',
                'This service is for users 18 and older only. Do not attempt to circumvent age restrictions.',
              )}
            </p>

            <h2 className="text-lg font-semibold text-dark-text dark:text-dark-text text-light-text mb-3">
              {t('legal.guidelines.noHarmfulContent.title', 'No Harmful Content')}
            </h2>
            <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary mb-4">
              {t(
                'legal.guidelines.noHarmfulContent.content',
                'Do not create or share content that promotes self-harm, violence, or dangerous activities.',
              )}
            </p>

            <h2 className="text-lg font-semibold text-dark-text dark:text-dark-text text-light-text mb-3">
              {t('legal.guidelines.privacySafety.title', 'Privacy and Safety')}
            </h2>
            <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary mb-4">
              {t(
                'legal.guidelines.privacySafety.content',
                'Do not share personal information that could compromise your safety or privacy. Remember that AI companions are not real people.',
              )}
            </p>

            <h2 className="text-lg font-semibold text-dark-text dark:text-dark-text text-light-text mb-3">
              {t('legal.guidelines.noSpamAbuse.title', 'No Spam or Abuse')}
            </h2>
            <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary mb-4">
              {t(
                'legal.guidelines.noSpamAbuse.content',
                'Do not use the service to spam, abuse system resources, or attempt to manipulate the AI in harmful ways.',
              )}
            </p>

            <h2 className="text-lg font-semibold text-dark-text dark:text-dark-text text-light-text mb-3">
              {t('legal.guidelines.reporting.title', 'Reporting Violations')}
            </h2>
            <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary mb-4">
              {t(
                'legal.guidelines.reporting.content',
                'If you encounter content or behavior that violates these guidelines, please report it to support@chatnexus.com',
              )}
            </p>

            <h2 className="text-lg font-semibold text-dark-text dark:text-dark-text text-light-text mb-3">
              {t('legal.guidelines.consequences.title', 'Consequences')}
            </h2>
            <p className="text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary">
              {t(
                'legal.guidelines.consequences.content',
                'Violations of these guidelines may result in content removal, account suspension, or permanent ban from the platform.',
              )}
            </p>
          </div>
        </div>
      </div>
    </MobileLayout>
  );
};

export default Guidelines;
